import { useState, useEffect } from 'react';
import { ChevronDown, Building2, Plus } from 'lucide-react';
import { entityService } from '../../services/entity/entityService';
import { UniversalEntity } from '../../../../shared/src/models/universal_entity';
import { useNavigate } from 'react-router-dom';

export function EntitySelector() {
    const [entities, setEntities] = useState<UniversalEntity[]>([]);
    const [selected, setSelected] = useState<UniversalEntity | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // In a real app, we'd get the clientId from context/auth
        const clientId = 'current-client-id';
        entityService.listEntities(clientId).then(list => {
            setEntities(list);
            if (list.length > 0) setSelected(list[0]);
        });
    }, []);

    const handleSelect = (entity: UniversalEntity) => {
        setSelected(entity);
        setIsOpen(false);
        // Here we would ideally set global context/state for current entity
        // and maybe navigate to that entity's dashboard
        console.log("Switched to entity:", entity.legalName);
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 px-3 py-2 rounded-lg bg-primary-800/50 hover:bg-primary-800 border border-primary-700 transition-colors w-64"
            >
                <div className="w-8 h-8 rounded-md bg-accent-500/20 flex items-center justify-center text-accent-400">
                    <Building2 className="w-4 h-4" />
                </div>
                <div className="flex-1 text-left truncate">
                    <div className="text-xs text-primary-400">Current Entity</div>
                    <div className="text-sm font-medium text-white truncate">
                        {selected ? selected.legalName : 'Select Entity...'}
                    </div>
                </div>
                <ChevronDown className="w-4 h-4 text-primary-400" />
            </button>

            {isOpen && (
                <div className="absolute top-full left-0 mt-2 w-full bg-primary-800 border border-primary-700 rounded-lg shadow-xl z-50 overflow-hidden">
                    <div className="max-h-64 overflow-y-auto">
                        {entities.map(entity => (
                            <button
                                key={entity.id}
                                onClick={() => handleSelect(entity)}
                                className="w-full text-left px-4 py-3 hover:bg-primary-700 transition-colors border-b border-primary-700/50 last:border-0 flex items-center gap-2"
                            >
                                <Building2 className="w-4 h-4 text-primary-400" />
                                <div>
                                    <div className="text-sm text-white font-medium">{entity.legalName}</div>
                                    <div className="text-xs text-primary-400 capitalize">{entity.type.replace(/_/g, ' ').toLowerCase()}</div>
                                </div>
                            </button>
                        ))}
                    </div>

                    <button
                        onClick={() => navigate('/intake/new-entity')}
                        className="w-full flex items-center gap-2 p-3 bg-primary-900/50 text-accent-400 text-sm font-medium hover:bg-primary-900 transition-colors border-t border-primary-700"
                    >
                        <Plus className="w-4 h-4" />
                        Create New Entity
                    </button>
                </div>
            )}
        </div>
    );
}
